import { fadeIn, fadeOut } from '../core/effects.js';

export function initScrollTop() {
  const buttons = document.querySelectorAll('.scroll-top');
  if (!buttons.length || document.documentElement.dataset.webtenseScrollTopInit) {
    return;
  }

  document.documentElement.dataset.webtenseScrollTopInit = 'true';

  function toggleScrollTop() {
    if (window.scrollY > 100) {
      buttons.forEach((button) => fadeIn(button));
    } else {
      buttons.forEach((button) => fadeOut(button));
    }
  }

  window.addEventListener('scroll', toggleScrollTop);
  toggleScrollTop();

  buttons.forEach((button) => button.addEventListener('click', (event) => {
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }));
}
